import { useState } from "react";
import { Modal, Button } from "react-bootstrap";

import { api_without_cancellation } from "../../api/api";

import RequestSentModal from "./request-sent-modal";

const RequestCoPilotModal = ({ show, handleClose, firm, refetch }) => {
  const [sending, setSending] = useState(false);
  const [error, setError] = useState(null);
  const [showSentModal, setShowSentModal] = useState(false);

  const handleSendRequest = async () => {
    setSending(true);
    setError(null);
    try {
      await api_without_cancellation.post("/api/copilot-page/create-request/", {
        to_firm: firm?.firm_id,
      });
      refetch();
      handleClose;
      setShowSentModal(true);
    } catch (err) {
      console.error("Error sending co-pilot request:", err);
      setError("Something went wrong sending your request. Please try again.");
    } finally {
      setSending(false);
    }
  };

  return (
    <>
      {show && (
        <Modal
          show={show}
          onHide={handleClose}
          dialogClassName="modal-dialog-centered"
          contentClassName="custom-modal-new-provider"
          size="md"
        >
          <div>
            <Modal.Header className="text-center height-25 p-0 bg-primary popup-heading-color justify-content-center">
              <Modal.Title
                className="mx-auto height-25 font-weight-semibold text-uppercase popup-heading-color font-weight-500"
                id="modal_title"
                style={{ fontSize: "14px" }}
              >
                Request Co Pilot
              </Modal.Title>
            </Modal.Header>
            <Modal.Body className="p-0 p-t-5 d-flex align-items-center justify-content-center">
              <div
                className="d-flex flex-column align-items-start justify-content-start"
                style={{ gap: "5px", padding: "0 0px" }}
              >
                <span
                  style={{ fontWeight: "600", color: "var(--primary)" }}
                  className="text-center"
                >
                  You are requesting <span style={{ fontWeight: "700" }}>{firm?.firm_name}</span> to
                  become a Co-Pilot
                </span>
                <span style={{ fontWeight: "600", color: "var(--primary)" }}>
                  If they accept your request:
                </span>
                <ul
                  className="text-start"
                  style={{
                    color: "var(--primary)",
                    fontWeight: "600",
                    paddingLeft: "0px",
                    margin: 0,
                  }}
                >
                  <li>You will be able to chat with their team.</li>
                  <li>You will gain access to documents they choose to share for this case.</li>
                </ul>
                {error && (
                  <span
                    style={{ fontWeight: "600", color: "var(--danger, #dc3545)" }}
                    className="whitespace-nowrap"
                  >
                    {error}
                  </span>
                )}
              </div>
            </Modal.Body>

            <Modal.Footer
              className="p-0 mt-0 padding-outside-btn-new-provider d-flex align-items-center justify-content-center"
              style={{ borderTop: "none", gap: "5px" }}
            >
              <Button
                className="button-padding-footer-new-provider d-flex align-items-center justify-content-center"
                variant="secondary"
                onClick={handleClose}
                disabled={sending}
              >
                Cancel
              </Button>
              <Button
                className="button-padding-footer-new-provider d-flex align-items-center justify-content-center"
                onClick={handleSendRequest}
                disabled={sending || !firm?.firm_id}
              >
                {sending ? "Sending..." : "Send Request"}
              </Button>
            </Modal.Footer>
          </div>
        </Modal>
      )}

      <RequestSentModal
        show={showSentModal}
        handleClose={() => {
          setShowSentModal(false);
          handleClose();
        }}
        firmName={firm?.firm_name}
      />
    </>
  );
};

export default RequestCoPilotModal;
